var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "mobile-multiselect-item",
        { "mobile-multiselect-item_selected": _vm.isSelected }
      ]
    },
    [
      _c("div", { staticClass: "mobile-multiselect-item__title" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
      ]),
      _c(
        "div",
        { staticClass: "mobile-multiselect-item__value" },
        [
          _vm._t("default", [
            _vm.isSelected
              ? _c(
                  "div",
                  { staticClass: "mobile-multiselect-item__default-icon" },
                  [
                    _c("f-sprite-icon", {
                      attrs: { "icon-link": _vm.$options.icons.IconCheck.id }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }